import { render, staticRenderFns } from "./c-clientes.vue?vue&type=template&id=33fd10ca&scoped=true&"
import script from "./c-clientes.vue?vue&type=script&lang=js&"
export * from "./c-clientes.vue?vue&type=script&lang=js&"
import style0 from "./c-clientes.vue?vue&type=style&index=0&id=33fd10ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd10ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VRow})
